<template>
	<main id="subPage" class="admin">
		<!-- 카테고리 -->
        <section id="category">
			<h2>관리자 메뉴</h2>
			<ul class="breadCrumb">
				<li class="home"></li>
				<li class="web">
					<p class="pageTxt">관리자 메뉴</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
						<li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
					</ul> 
				</li>
                <li class="web">
					<p class="pageTxt">게시판 관리</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
						<li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
						<li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
						<li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
						<li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
					</ul> 
				</li>
                <li>
					<p class="pageTxt">자주묻는질문 관리</p>
					<ul class="depth">
						<li><router-link to="/noticemanagement" title="공지사항 관리">공지사항 관리</router-link></li>
						<li><router-link to="/faqmanagement" title="자주묻는질문 관리">자주묻는질문 관리</router-link></li>
					</ul> 
				</li>
			</ul>
        </section>

		<!-- 컨텐츠 영역 -->
		<section id="content">
			<div class="inner">
				<h3 class="pageTitle">자주묻는질문 수정</h3>
                <article>
                    <!--table-->
                    <div class="table horizontal-table">
                        <table>
                            <caption>자주묻는질문 수정 테이블</caption>
                            <colgroup>
                                <col style="width: 15%; min-width: 80px;">
                                <col style="width: auto;">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th scope="row">제목<span class="redDot">*</span></th>
                                    <td>
                                        <input type="text" title="제목 입력" v-model="title">
										<div class="error" v-if="!$v.title.required">필수 입력란입니다.</div>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">내용<span class="redDot">*</span></th>
                                    <td>
                                      <div id="ckeditorTA">
                                        <ckeditor
                                          :editor="editor"
                                          v-model="cts"
                                          @input="ctsInput"
                                          :config="editorConfig"
                                          @ready="onReady"
                                        ></ckeditor>
                                      </div>
                                      <div class="error" v-if="cts == '' && ctsChk">필수 입력란입니다.</div>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">첨부파일</th>
                                    <td>
                                        <div class="fileArea">
                                            <p class="upload-name">{{firstName}}</p>
                                            <input type="file" class="hidden" id="file" ref="files" @change="changeFile" @click="resetFile" />
                                            <label for="file" class="btn gray">파일첨부</label>
                                        </div>
                                        <p class="info">첨부파일 (최대용량:20M) *이미지 파일 (jpg, jpeg, gif, png, pdf)</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--table-->
                </article>
                <article class="btnArea">
                    <button class="btn border" @click="$router.push('faqmanagement')">목록</button>
                    <button class="btn gray" @click="$router.push('faqmanagement')">취소</button>
                    <button class="btn blue" @click="updateBtn">수정</button>
                </article>
            </div>
        </section>
	</main>
</template>

<script>
import axios from "../../../util/axios";
import { required }  from 'vuelidate/lib/validators'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor      from '@ckeditor/ckeditor5-vue2';
import '@ckeditor/ckeditor5-build-classic/build/translations/ko';
import { MyCustomUploadAdapterPlugin } from '../../../assets/js/UploadAdapter';

export default {
  name: 'ckeditorTA',
	data(){
		return {
			cts                : '',
			title              : '',
			atclId             : '',
			editor             : ClassicEditor,
			submitStatus       : '',
			eFiles             : '',
			existFiles         : '',
			menuUrl            : "/api/admin/board/faq",
			firstName		   : '',

			editorConfig       : {
				language         : 'ko',
				enterMode        : 2,
				shiftEnterMode   : 3,
				extraPlugins     : [ MyCustomUploadAdapterPlugin ],
				mediaEmbed       : {
					previewsInData : true,
				}
			},
      test: [v => !!v || '필수 입력란입니다.'],
      ctsChk: false,
		}
	},

	validations: {
		title : {
			required
		},
		cts : {
			required
		}
	},

	components: {
		ckeditor : CKEditor.component,
	},

  created() {
    var data = this.$route.params.data;

    if (data == null) {
      data = JSON.parse(localStorage.getItem('faqManageData'));
    } else {
      localStorage.setItem('faqManageData', JSON.stringify(data));
    }

    this.atclId = data.atclId;
    this.title = data.title;
    this.cts = data.cts;
    this.existFiles = data.eFiles;
  },
	
	mounted(){
		const data = this.$route.params.data;
        if(!data) {
			alert("잘못된 접근입니다.");
			this.$router.push('/faqmanagement');
        }
        this.atclId = data.atclId;
		this.title = data.title;
		this.cts = data.cts;
		this.existFiles = data.eFiles;
        this.initAttachList();
	},

  async getNoticeData() {
    const apiParams = new FormData();
    apiParams.append('atclId', this.atclId);
    const res = await axios('get', '/api/admin/board/faq/view.json', {
      atclId: this.atclId,
      bbsCd: this.bbsCd,
    });
    const data = res.data.boardView;
    this.atclId = data.atclId;
    this.cts = data.cts;
    this.title = data.title;
    this.regNm = res.data.regNm;
    this.regDttm = res.data.regDttm;
  },

	methods: {
		async initAttachList() {
			const res = await axios('get', "/api/admin/board/faq/getAttachList.json", {
                atclId: this.atclId,
			});
			this.existFiles = res.data.attachList;
		},

		initEFiles(){
			if(this.eFiles.length == 0){
				this.eFiles = '';
			}
		},

		onReady(editor){
			editor.ui.getEditableElement().parentElement.insertBefore(
				editor.ui.view.toolbar.element,
				editor.ui.getEditableElement()
			);
		},

    ctsInput() {
      if (this.ctsChk) {
        return;
      }
      this.ctsChk = true;
    },

		async updateBtn() {			
			if(this.$v.$invalid) {
				return;
			} 
			
			this.initEFiles();
			let apiParams = new FormData();
			apiParams.append("atclId", this.atclId);
			apiParams.append("title", this.title);
			apiParams.append("cts", this.cts);
			if(this.eFiles !== '') {
				this.eFiles.forEach(e => {
					apiParams.append("files", e);
				});
			}

			await axios('post', "/api/admin/board/faq/updateAction.json", apiParams);
			this.$router.push('faqmanagement');
		},

		changeFile(e) {
			const file = e.target.files[0];
			
			if (file.size > 2000000) {
				alert('최대 20mb까지 업로드할 수 있습니다.');
				this.resetFile();
				return;
			}

			if (file['type'] === 'image/jpeg' || file['type'] === 'image/png' || file['type'] === 'image/gif' || file['type'] === 'image/jpg' || file['type'] === 'image/pdf' || file['type'] == 'application/pdf') {
				this.firstName = file.name;
				this.eFiles = file;
			}
		},

		resetFile(){
			this.$refs.files.value = '';
			this.eFiles = [];
		},

		downloadAttachFile(filePath, saveNm, viewNm, fileExt, repoId) {
			location.href = this.menuUrl + "/download.json?filePath=" + filePath + "&saveNm=" + saveNm + "&viewNm=" + viewNm + "&fileExt=" + fileExt + "&repoId=" + repoId;
		},

		async deleteAttachFile(filePath, saveNm, atchFileId, fileExt, repoId){
			let apiParams = new FormData();
			apiParams.append("filePath", filePath);
			apiParams.append("saveNm", saveNm);
			apiParams.append("atchFileId", atchFileId);
			apiParams.append("fileExt", fileExt);
			apiParams.append("repoId", repoId);
			await axios('post', "/api/admin/board/faq/deleteAttachFile.json", apiParams);
			await this.initAttachList();
		},
	},
}
</script>

